
export const expectedPdWebhooksToCreateTasks = ({ expectedWebhooks, currentAccountMapping }) => {
  const {
    id: currentAccountMappingId,
    jira: {
      browse_base_url: jira_browse_url,
    } = {},
  } = currentAccountMapping;
  const result = {};

  // eslint-disable-next-line no-unused-vars
  for (const { service, used_by_rules } of expectedWebhooks.filter(w => w.type === 'pagerduty_webhook')) {
    const name = `JIRA_integration_${currentAccountMappingId}_${service.id}`;
    const config = { jira_browse_url };

    result[name] = {
      key: name,
      createTask: {
        type: 'pd',
        action: 'create',
        service,
        webhookName: name,
        webhookConfig: config,
        used_by_rules,
      }
    };
  }

  return result;
};
